import CaseStudyCard from "../../reusables/CaseStudyCard";
import agma from "../../../assets/images/case-studies/agma.jpg";

const AgmaCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={agma}
      client="AY Gold Mountain Academy"
      solution="ICT Infrastructure Setup"
      title="A complete school ICT infrastructure setup and equipments supply"
      subtitle="This modern school wanted a complete ICT setup and equipments supply for the digital era."
      link="/solutions/ict-consultancy"
    >
      <li>
        ✔︎ <span>School badge design</span>
      </li>
      <li>
        ✔︎ <span>School management system</span>
      </li>
      <li>
        ✔︎ <span>Computer labs & offices ICT setup</span>
      </li>
      <li>
        ✔︎ <span>Website design & development</span>
      </li>
      <li>
        ✔︎ <span>Computers & printers supply</span>
      </li>
    </CaseStudyCard>
  );
};

export default AgmaCaseStudyCard;
